/**
 * MODULE: _shared/frontend-shell/src/features/crm/utils/formatActivityRelativeTime.ts
 * PURPOSE: Relative time label for activity timeline rows (Prompt 3-C)
 * DEPENDENCIES: date-fns
 * PUBLIC_API: formatActivityRelativeTime
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: ~25/150
 */

import { formatDistance, isValid, parseISO } from 'date-fns';

/** @param now Reference instant for “X ago” (defaults to current time; inject in tests). */
export function formatActivityRelativeTime(iso: string, now: Date = new Date()): string {
  const d = parseISO(iso);
  if (!isValid(d)) return '—';
  return formatDistance(d, now, { addSuffix: true });
}
